import React, { ReactNode, createContext, useContext } from "react"

import { InstallationReference } from "shared/types/InstallationReference"
import { ProductPositionInstallationReference } from "shared/types/__generated__/graphql"

import { ClarificationRequestModel } from "entities/clarification-requests/types/ClarificationRequestModel"
import { ProductPositionFormState } from "entities/product-positions/types/ProductPositionForm"

export interface ProductPositionFormFeaturesContextValue {
  formData?: ProductPositionFormState
  isConfigurationDisabled?: boolean
  openPortfolio?: () => void
  openProductConfiguration?: () => void
  openProductDimensioning?: () => void
  installationReferences?: InstallationReference[]
  productPositionInstallationReferences?: ProductPositionInstallationReference[]
  openInstallationReferenceSelection?: () => void
  openInstallationReferenceImage?: (content: ReactNode, title: string) => void
  deleteInstallationReference?: (id: string) => void
  clarificationRequest?: ClarificationRequestModel | null
  hasClarificationRequest?: boolean
}

const ProductPositionFormFeaturesContext = createContext<
  ProductPositionFormFeaturesContextValue | undefined
>(undefined)

export interface ProductPositionFormFeaturesProviderProps {
  value: ProductPositionFormFeaturesContextValue
  children: React.ReactNode
}

export const ProductPositionFormFeaturesProvider = React.memo(
  ({ value, children }: ProductPositionFormFeaturesProviderProps) => (
    <ProductPositionFormFeaturesContext.Provider value={value}>
      {children}
    </ProductPositionFormFeaturesContext.Provider>
  )
)

export function useProductPositionFormFeaturesContext(): ProductPositionFormFeaturesContextValue {
  const context = useContext(ProductPositionFormFeaturesContext)
  if (!context) {
    throw new Error(
      "useProductPositionFormFeaturesContext must be used within a ProductPositionFormFeaturesProvider"
    )
  }
  return context
}
